module.exports = __webpack_public_path__ + "img/popsugar-fitness.b79e4dae.jpg";